import { createGlobalStyle } from 'styled-components';

//Variables
import { Color, FontSize } from './theme';


export const GlobalStyle = createGlobalStyle`
  html, body {
    background: ${Color.White};
    color: ${Color.Black};
    font-family: 'Open Sans', sans-serif;
    font-size: ${FontSize.XS};
    font-weight: bold;
    padding: 0;
    margin: 0;
    width: 100%;
  }
  
  h1, h2, h3 {
    display: block;
    margin: 0;
    padding: 0;
  }
  
  a {
    color: inherit;
    text-decoration: none;
  }
  
  * {
    box-sizing: border-box;
  }
`;



// WEBPACK FOOTER //
// ./src/utils/styles/global.style.js